module.exports = __webpack_public_path__ + "img/home_default.57b0ff63.svg";